import { Box, Switch, Typography } from "@mui/material";
import { IncidentDateFieldSwitchProps } from "../types";
import { incidentTableStyles } from "./styles";

export function IncidentDateFieldSwitch({
  value,
  onChange,
}: IncidentDateFieldSwitchProps) {
  const isDetectionTimeSelected = value === "incidentSpecificTime";

  return (
    <Box sx={incidentTableStyles.dateFieldSwitchContainerSx}>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: !isDetectionTimeSelected ? 700 : 400,
          color: !isDetectionTimeSelected ? "brand.earthly" : "inherit",
        }}
      >
        Scanned At
      </Typography>

      <Switch
        checked={isDetectionTimeSelected}
        onChange={(_, checked) =>
          onChange(checked ? "incidentSpecificTime" : "scannedAt")
        }
        sx={{
          "& .MuiSwitch-switchBase": {
            color: "brand.earthly",
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "brand.earthly",
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "brand.earthly",
          },
        }}
      />

      <Typography
        sx={{
          fontSize: 13,
          fontWeight: isDetectionTimeSelected ? 700 : 400,
          color: isDetectionTimeSelected ? "brand.earthly" : "inherit",
        }}
      >
        Detection Time
      </Typography>
    </Box>
  );
}
